import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../pages/main/header";
import Nav from "../pages/main/nav";
import Footer from "../pages/main/footer";
import DateRange from "../pages/main/DateRange";
import Swal from "sweetalert2";
import axios from "axios";

import { AccessToken, APIBaseURL, AppBaseURL } from "../Config";
import { formatToDateTime, formatToDateTime1 } from "../pages/main/formatToDateTime";

export default function LSCReport() {
  const [type, setType] = useState("Container TAT");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);


  const [order, setOrder] = useState('asc');
  const [container_no, setContainerNo] = useState('');
  const [sline, setSline] = useState('');
  const [days, setDays] = useState(null);
  const [maxDays, setMaxDays] = useState(null);

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `${APIBaseURL}/rake/long_stating_containers?page=` + page;

    if (container_no) {
      url += `&container_no=${container_no}`;
    }
    if (sline) {
      url += `&sline=${sline}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if(days){
      url += `&days=${days}`;
    }
    if(maxDays){
      url += `&maxDays=${maxDays}`;
    }

    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          access_token: `${AccessToken}`,
        },
      });
      if (response.data && response.data.data) {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "info",
          text: "Something went wrong..!",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    GetData();
  }, [container_no, days,sline,order,maxDays]);

  const handleDataFilter = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setContainerNo(formData.get("container_no") || "");
    setDays(formData.get("days") || "");
    setMaxDays(formData.get("maxDays") || "");
    setSline(formData.get("sline") || "");
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
             
                {/* <ReportsManu/> */}

                <div className="row justify-content-between my-3">
                  <div className="card">
                    <div className="card-body">
                    <h3 className="text-primary">  Long Standing Container (60 Days Plus ) </h3>
                      <form
                        className="needs-validation"
                        noValidate=""
                        onSubmit={handleDataFilter}
                      >
                        <div className="row">

                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                id="container_no"
                                name="container_no"
                              />
                              <label htmlFor="container-name">
                                Container Number
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                id="sline"
                                name="sline"
                              />
                              <label htmlFor="sline">
                              Shipping Line 
                              </label>
                            </div>
                          </div>

                          <div className="col-md-2">
                              <div className="form-floating form-floating-outline mb-3">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="numberOFDays"
                                  name="days"
                                />
                                <label htmlFor="numberOFDays">
                                  Enter No. of Days (Min)
                                </label>
                              </div>
                            </div>
                          <div className="col-md-2">
                              <div className="form-floating form-floating-outline mb-3">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="numberOFDays"
                                  name="maxDays"
                                />
                                <label htmlFor="numberOFDays">
                                  Enter No. of Days (Max)
                                </label>
                              </div>
                            </div>


                          <div className="col-md-3">
                            <button
                              type="button"
                              onClick={()=>setOrder(order=='asc'?'desc':'asc')}
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                             <i className={` ri-20px ri-sort-${order}`}></i>
                            </button>
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            {/* <button
                              type="button"
                              // onClick={handleDownload}
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-download-fill ri-20px" />
                            </button> */}
                            <button
                              type="button"
                              onClick={() => window.location.reload()}
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-restart-line ri-20px" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>


                <div className="row my-3">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>S.No.</td>
                              <td>Container No.</td>
                              <td>Container Size</td>
                              <td>Sline</td>
                              <td>Inward Timestamp</td>
                              <td>Ageing</td>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data &&
                              data?.data.map((report, index) => (

                                <tr key={index}>
                                  <td>
                                    <span>{index + 1}</span>
                                  </td>
                                  <td>
                                    <span>{report.container_no}</span>
                                  </td>
                                  <td>
                                    <span>{report.container_size}Ft</span>
                                  </td>
                                  <td>
                                    <span>{report.slinecode}</span>
                                  </td>
                                  <td>
                                    <span>{formatToDateTime(report.in_time)}</span>
                                  </td>
                                  {/* <td>
                                      <span>
                                        {Math.floor((new Date() - new Date(report.in_time)) / (1000 * 60 * 60 * 24))} days ago
                                      </span>
                                  </td> */}

                                  <td>
                                    <span>
                                      {(() => {
                                        const getDateDifference = (startDate, endDate = new Date()) => {
                                          const start = new Date(startDate);
                                          const end = new Date(endDate);

                                          let years = end.getFullYear() - start.getFullYear();
                                          let months = end.getMonth() - start.getMonth();
                                          let days = end.getDate() - start.getDate();

                                          if (days < 0) {
                                            months--;
                                            const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
                                            days += prevMonth.getDate();
                                          }

                                          if (months < 0) {
                                            years--;
                                            months += 12;
                                          }

                                          return { years, months, days };
                                        };

                                        const { years, months, days } = getDateDifference(report.in_time);

                                        return `${years > 0 ? `${years} year${years > 1 ? 's' : ''} ` : ''}${months > 0 ? `${months} month${months > 1 ? 's' : ''} ` : ''
                                          }${days > 0 ? `${days} day${days > 1 ? 's' : ''} ` : ''}`;
                                      })()}
                                    </span>
                                  </td>

                                </tr>
                              )
                              )}
                          </tbody>
                        </table>
                        {data && data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {data.from} to {data.to} of{" "}
                                  {data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {data &&
                                      data.links &&
                                      data.links.map((link, q) => {
                                        let showData =
                                          data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                              ? "Previous"
                                              : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${link.active === true
                                              ? "active"
                                              : ""
                                              }  ${showData == "Next" &&
                                                data.current_page ==
                                                data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  data.current_page == 1
                                                  ? "disabled"
                                                  : ""
                                              } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(data.current_page - 1
                                                  )
                                                  : showData == "Next"
                                                    ? GetData(data.current_page + 1
                                                    )
                                                    : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>


              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
